// biome-ignore format: historic
// biome-ignore format: historic
// components
import Icon, { type IconType } from '@components/Icon/Icon';

// types
import type {
  EmailSignatureContactDetailsFieldTypes,
  EmailSignatureFootersAndBannerTypes,
  EmailSignatureImagesTypes,
  EmailSignatureSocialLinkTypes,
} from '../types';
import styles from './EmailSignatureEditorNewFieldButton.module.scss';

interface EmailSignatureEditorNewFieldButtonProps<T> {
  subtitle: string;
  type: T;
  onActivate: (type: T) => void;
  disabled?: boolean;
}

function EmailSignatureEditorNewFieldButton<
  T extends
    | EmailSignatureContactDetailsFieldTypes
    | EmailSignatureSocialLinkTypes
    | EmailSignatureFootersAndBannerTypes
    | EmailSignatureImagesTypes,
>(props: EmailSignatureEditorNewFieldButtonProps<T>): React.ReactElement {
  return (
    <button
      disabled={props.disabled}
      onClick={() => props.onActivate(props.type)}
      className={styles['new-field-button']}
      data-is-disabled={props.disabled?.toString()}
    >
      <span>
        <Icon type={props.type as unknown as IconType} />
      </span>
      <span className={styles['new-field-button-subtitle']}>{props.subtitle}</span>
    </button>
  );
}

export default EmailSignatureEditorNewFieldButton;
